/* eslint-disable */
import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server'
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import {
  Container,
  Grid,
  Segment,
  Header,
  Divider,
  Table,
  Button
} from 'semantic-ui-react';
import { useCurrentUser } from '../../_services/hooks';
import {
  useCustomer,
  useCustomerBillingAccount,
  useCustomerBills
} from '../../_services';
import { history } from '../../_helpers';

const moment = extendMoment(Moment);
const ROWS_PER_ADDRESSES = 6;
const ROWS_PER_TOTALS = 2;
const ROWS_PER_PAGE = 20;

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const shortMonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const isPaymentTransaction = t => ['Payment'].includes(t.transaction_name);

const isChargingTransaction = t => ['Charging'].includes(t.transaction_name);

const isCreditTransaction = t => ['Credit', 'ChargingCredit', 'ReferralCredit', 'ChargingIncentive', 'EndOfCreditPeriod', 'FullCredit', 'RebrandSurveyCredit'].includes(t.transaction_name);

const isCorrectionTransaction = t => ['ChargingCorrection', 'TariffCorrection', 'Refund'].includes(t.transaction_name);

const getTransactionDescription = t => {
  // For charging sessions, show street name
  if (isChargingTransaction(t)) return t.location;

  const transactionDescriptions = {
    'Payment': 'Card payment, thank you',
    'Credit': 'Credit to your account',
    'Refund': 'Refund',
    'ChargingCorrection': 'Charging session correction',
    'ChargingCredit': 'HUB Charging Credit',
    'ReferralCredit': 'Referral Bonus',
    'ChargingIncentive': 'Charging Incentive',
    'EndOfCreditPeriod': 'Incentive / Bonus Expiry',
    'TariffCorrection': 'Tariff Correction',
    'FullCredit': 'Credit for Full Session',
    'RebrandSurveyCredit': 'Survey Completion',
    'AONInstallSupplement': 'HOME Installation Supplement',
    'AonInitialPayment': 'HOME Initial Payment',
    'AonRecurringPayment': 'HOME Recurring Payment',
    'HubInitialPayment': 'HUB Initial Deposit'
  };

  const description = transactionDescriptions[t.transaction_name];

  // Default to name if no description found
  return description ? description : t.transaction_name;
};

const amountInPence = amount => {
  if (isNaN(amount)) return 0;

  // Convert to pence e.g. account.account.balance_whpence 130750 = £1.31
  // Round DOWN to match Stripe
  if (amount < 0)
    return 0 - Math.floor((0 - amount) / 1000);
  else
    return Math.floor(amount / 1000);
};

const formatCurrency = (currency, amountPounds) => {
  const absAmountPounds = Math.abs(amountPounds);
  return (
    (amountPounds < 0 ? '-' : '') +
    currency +
    absAmountPounds.toFixed(2)
  );
};

const CustomerVATReceiptPDFPage = ({customer, month, page, numPages}) => {
  // Calculate totals
  let billedMonthNetAmount = 0;
  let billedMonthTotalVAT = 0;
  let billedMonthTotalAmount = 0;

  let consumedMonthNetAmount = 0;
  let consumedMonthTotalVAT = 0;
  let consumedMonthTotalAmount = 0;
  let consumedKwh = 0;

  let correctedMonthNetAmount = 0;
  let correctedMonthTotalVAT = 0;
  let correctedMonthTotalAmount = 0;

  let creditedMonthNetAmount = 0;
  let creditedMonthTotalVAT = 0;
  let creditedMonthTotalAmount = 0;

  if (page === numPages) {
    month.transactions.forEach((t) => {
      if (isPaymentTransaction(t)) {
        billedMonthNetAmount +=  t.netAmountPounds;
        billedMonthTotalVAT += t.vatPounds;
        billedMonthTotalAmount += t.amountPounds;
      }

      if (isChargingTransaction(t)) {
        consumedMonthNetAmount += t.netAmountPounds < 0 ? t.netAmountPounds * -1 : t.netAmountPounds;
        consumedMonthTotalVAT += t.vatPounds < 0 ? t.vatPounds * -1 : t.vatPounds;
        consumedMonthTotalAmount += t.amountPounds < 0 ? t.amountPounds * -1 : t.amountPounds;
        consumedKwh += t.consumption_kwh
      }

      if (isCorrectionTransaction(t)) {
        correctedMonthNetAmount += t.netAmountPounds;
        correctedMonthTotalVAT += t.vatPounds;
        correctedMonthTotalAmount += t.amountPounds;
      }

      if (isCreditTransaction(t)) {
        creditedMonthNetAmount += t.netAmountPounds;
        creditedMonthTotalVAT += t.vatPounds;
        creditedMonthTotalAmount += t.amountPounds;
      }
    });
  }

  return (
    <div
      id={`pdf_${month.year}_${month.month}_page${page}`}
      className="pdf1"
    >
      {page === 1 && (
        <>
      		<div className="Header">
      			<div className="TE-Logo">
      				<img align="left" src="/images/TEL_logo_land_neg_outline_teal_pdf.png" width="149" height="89" alt="Trojan Energy Logo"/>
      			</div>
      	  </div>
      		<div className="TE-Details">
      			<p><strong>Trojan Energy Limited</strong><br/>
      				W-Zero-1 Building<br/>
      				Energy Transition Zone<br/>
      				Hareness Road<br/>
      				Aberdeen<br/>
      				AB12 3LE
      			</p>
      			<p>Vat No: GB 320 6441 41</p>
      		</div>

      	  <div className="Customer-Details">
      			<p><strong>Customer</strong><br/>
              {customer.forename}{' '}{customer.surname}<br/>
              {customer.address_line1}{customer.address_line1 ? <br/> : ''}
              {customer.address_line2}{customer.address_line2 ? <br/> : ''}
              {customer.address_city}{customer.address_city ? <br/> : ''}
              {customer.address_postcode}<br/>
    		  	</p>
    		  	<p></p>
      		</div>
        </>
      )}
      <div className="Charging-Summary">
        <p><strong>ITEMISED STATEMENT</strong></p>
        <p>1 - {month.num_days}{' '}{shortMonthNames[month.month]} {month.year}</p>
        <table width="100%">
          <tbody>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Street</th>
              <th scope="col">Consumption</th>
              <th scope="col">Net</th>
              <th scope="col">VAT</th>
              <th scope="col">Total</th>
            </tr>

            {month.transactions.map((t, t_idx) => {
              let startIdx = 0;
              let numTransactions = ROWS_PER_PAGE;

              // Make space for header and/or footer
              if (page === numPages) numTransactions -= ROWS_PER_TOTALS;
              if (page === 1)
                numTransactions -= ROWS_PER_ADDRESSES;
              else
                startIdx = (ROWS_PER_PAGE * (page - 1)) - ROWS_PER_ADDRESSES;

              // Only display this page's transactions
              const display = (t_idx >= startIdx && t_idx < startIdx + numTransactions);
              // console.log(page, numPages, startIdx, t_idx, numTransactions, display);
              return display ? (
                <tr key={t_idx}>
                  <td>{t.dates}</td>
                  <td>{t.description}</td>
                  <td className="Subtotals">{t.consumption_kwh > 0 ? t.consumption_kwh + 'kWh' : ''}</td>
                  <td className="Subtotals">{formatCurrency('£', t.netAmountPounds)}</td>
                  <td className="Subtotals">{formatCurrency('£', t.vatPounds)}</td>
                  <td className="Subtotals">{formatCurrency('£', t.amountPounds)}</td>
                </tr>
              ) : (
                ''
              );
            })}
          </tbody>
        </table>
      </div>

      {page === numPages && (
        <div className="Charging-Summary">
          <p><strong>SUMMARY</strong></p>
          <table width="100%">
            <tbody>
              <tr>
                <th scope="col">
                  Transaction Type
                </th>
                <th scope="col">
                  Net
                </th>
                <th scope="col">
                  VAT
                </th>
                <th scope="col">
                  Gross
                </th>
              </tr>
              <tr>
                <td>
                  <strong>Payments Received</strong>
                </td>
                <td>
                  {formatCurrency('£', billedMonthNetAmount)}
                </td>
                <td>
                  {formatCurrency('£', billedMonthTotalVAT)}
                </td>
                <td>
                  {formatCurrency('£', billedMonthTotalAmount)}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Charging Consumption</strong>
                </td>
                <td>
                  {formatCurrency('£', consumedMonthNetAmount)} ({consumedKwh}kWh)
                </td>
                <td>
                  {formatCurrency('£', consumedMonthTotalVAT)}
                </td>
                <td>
                  {formatCurrency('£', consumedMonthTotalAmount)}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Corrections</strong>
                </td>
                <td>
                  {formatCurrency('£', correctedMonthNetAmount)}
                </td>
                <td>
                  {formatCurrency('£', correctedMonthTotalVAT)}
                </td>
                <td>
                  {formatCurrency('£', correctedMonthTotalAmount)}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Credits</strong>
                </td>
                <td>
                  {formatCurrency('£', creditedMonthNetAmount)}
                </td>
                <td>
                  {formatCurrency('£', creditedMonthTotalVAT)}
                </td>
                <td>
                  {formatCurrency('£', creditedMonthTotalAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      <div className="Footer">
        <p><strong>t:</strong> 0800 0854 644 <strong>e:</strong> support@trojan.energy <strong>w:</strong> trojan.energy<br/>
        Trojan Energy Limited is a company registed in Scotland with company registration number SC547728</p>
      </div>
      <div className="Pages">
    		<p><strong>Page {page} of {numPages}</strong></p>
    	</div>
    </div>
  );
};

export const CustomerStatement = () => {
  const { currentUser, currentUserIsCustomer, customerId } = useCurrentUser();
  const { customer } = useCustomer(customerId);

  const [months, setMonths] = useState([]);
  const [download, setDownload] = useState(false);

  const [pdf, setPdf] = useState(null);
  const [pdfMonth, setPdfMonth] = useState(null);
  const [pdfNumPages, setPdfNumPages] = useState(0);
  const [pdfNextPage, setPdfNextPage] = useState(0);

  const account = useCustomerBillingAccount(customerId);
  const transactions = useCustomerBills(account ? account.id : null);

  useEffect(() => {
    if (!pdf || !pdfNumPages || !pdfNextPage) return;

    const page = pdfNextPage;
    const month = pdfMonth;
    const lastPageId = `pdf_${month.year}_${month.month}_page${pdfNumPages}`;

    const elementId = "iframe" + page;
    let input = document.getElementById(elementId).contentWindow.document.body;

    html2canvas(input, {
      onclone: function(clonedDoc) {
        // clonedDoc.getElementById(id).style.display = 'block';
      }
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const imgProps = pdf.getImageProperties(imgData);
      const width = pdf.internal.pageSize.getWidth();
      const height = (imgProps.height * width) / imgProps.width;

      const id = `pdf_${month.year}_${month.month}_page${page}`;
      pdf.addImage(imgData, 'JPEG', 0, 0, width, height, `page${id}`, 'FAST');
      if (id !== lastPageId) {
        pdf.addPage();
        setPdfNextPage(pdfNextPage + 1);
      } else {
        pdf.save(`TrojanStatement_${month.year}_${String(month.month + 1).padStart(2, '0')}.pdf`);
        setPdfNextPage(0);
      }
    });
  }, [pdf, pdfNumPages, pdfNextPage]);

  useEffect(() => {
    let months = [];
    let year = null;
    let month = null;
    let day = null;
    let monthTransactions = [];

    transactions.forEach((t, i) => {
      const from_ts = moment(t.from_datetime, 'YYYY-MM-DDTHH:mm:ss,Z');
      const from_t = from_ts.format('HH:mm');
      const from_d = from_ts.format('D MMM');

      let from_d_heading = from_d;
      if (from_d_heading === day) from_d_heading = '';
      else day = from_d;

      if (from_ts.year() !== year || from_ts.month() !== month) {
        year = from_ts.year();
        month = from_ts.month();
        const num_days = moment(`${year}-${month + 1}`, 'YYYY-M').daysInMonth();

        monthTransactions = [];
        months.push({
          year: year,
          month: month,
          num_days: num_days,
          transactions: monthTransactions
        });
      }

      let description = getTransactionDescription(t);

      let to_t = '';
      let to_d = '';
      let dates = `${from_d} @ ${from_t}`;
      let consumption_kwh = 0;
      let consumption = '';

      if (isCorrectionTransaction(t)) {
        dates = moment(t.from_datetime, 'YYYY-MM-DDTHH:mm:ss,Z').format('D MMM @ HH:mm');
      }

      if (isChargingTransaction(t)) {
        const to_ts = moment(t.to_datetime, 'YYYY-MM-DDTHH:mm:ss,Z');
        to_t = to_ts.format('HH:mm');
        to_d = to_ts.format('D MMM');
        dates = `${dates} to ${to_d} @ ${to_t}`;

        // Default to 'Charging'
        consumption_kwh = t.consumption_wh / 1000;
        consumption = `${t.consumption_kwh} kWh`;
        description = `${t.location}, ${consumption_kwh}kWhr`;
      }

      const costKPence = parseInt(t.cost_kpence);
      const amount = isCreditTransaction(t) || isPaymentTransaction(t) || isCorrectionTransaction(t) ? costKPence : -costKPence; // Display debits as -ve

      const amountPence = amountInPence(amount);
      const vatPence = Math.round(amountPence / 6);
      const netAmountPence = amountPence - vatPence;

      // Only display non-zero transactions
      if (consumption_kwh || amount != 0) {
        monthTransactions.push({
          transaction_name: t.transaction_name,
          from_day_heading: from_d_heading,
          from_day: from_d,
          from_time: from_t,
          to_day: to_d,
          to_time: to_t,
          dates: dates,
          description: description,
          location: t.location,
          netAmountPounds: netAmountPence / 100,
          vatPounds: vatPence / 100,
          amountPounds: amountPence / 100,
          consumption_kwh: consumption_kwh,
          consumption: consumption
        });
      }
    });

    setMonths(months);
  }, [transactions]);

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  if (!currentUserIsCustomer) {
    history.push(`/404`);
  }

  const downloadPDF = month => {
    const numPages = Math.ceil((ROWS_PER_ADDRESSES + month.transactions.length + ROWS_PER_TOTALS) / ROWS_PER_PAGE);

    for (let page = 1; page <= numPages; page++) {
      const html = ReactDOMServer.renderToString(
        <section className="sheet padding-10mm">
          <article>
            <CustomerVATReceiptPDFPage
              customer={customer}
              month={month}
              page={page}
              numPages={numPages}
            />
          </article>
        </section>
      );

      const elementId = "iframe" + page;
      let iframe = document.createElement("iframe");
      iframe.setAttribute("id", elementId);
      iframe.setAttribute("src", "about:blank");
      iframe.style.width = "210mm";
      iframe.style.height = "297mm";
      document.body.appendChild(iframe);

      let doc = document.getElementById(elementId).contentWindow.document;
      doc.open();
      doc.write('<!DOCTYPE html>');
      doc.write('<html lang="en">');
      doc.write('  <head>');
      doc.write('    <meta charset="utf-8">');
      doc.write('    <title>Trojan Energy - VAT Receipt</title>');
      doc.write('    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css">');
      doc.write('    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.css">');
      doc.write('  	 <link rel="stylesheet" href="/images/vat_receipt.css">');
      doc.write('    <style>@page { size: A4 }</style>');
      doc.write('  </head>');
      doc.write('  <body class="A4">');
      doc.write(html);
      doc.write('  </body>');
      doc.write('</html>');
      doc.close();
    }

    const pdf = new jsPDF('p', 'px', 'a4');
    setPdf(pdf);
    setPdfMonth(month);
    setPdfNumPages(numPages);
    setPdfNextPage(1);
  };

  return (
    <div>
      <div>
        <Container>
          <Grid centered padded>
            <Grid.Column style={{ maxWidth: 500 }}>
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">STATEMENT</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <p className="large text">
                        Balance{' '}
                        {account
                          ? formatCurrency('£', -amountInPence(account.balance_whpence) / 100)
                          : '-'}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider hidden />
                <Grid>
                  {months.map((m, m_idx) => (
                    <>
                      <Table key={m_idx} basic="very" celled fixed>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell
                              width={8}
                              style={{ fontSize: '19px', padding: '1em 0em' }}
                            >
                              {monthNames[m.month]} {m.year}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                              width={2}
                              style={{
                                fontSize: '19px',
                                padding: '0em 0em 0em 0em',
                                textAlign: 'center'
                              }}
                            >
                              <Button
                                onClick={() => {
                                  downloadPDF(m);
                                }}
                                color="olive"
                              >
                                <b>↓</b>
                              </Button>
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                      </Table>
                      <Table basic="very" celled fixed>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell width={2}>Date</Table.HeaderCell>
                            <Table.HeaderCell width={3}>Time</Table.HeaderCell>
                            <Table.HeaderCell width={8}>
                              Transaction
                            </Table.HeaderCell>
                            <Table.HeaderCell style={{ textAlign: 'right' }}>
                              Amount
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {m.transactions.map((t, t_idx) => (
                            <Table.Row key={t_idx}>
                              <Table.Cell>{t.from_day_heading}</Table.Cell>
                              <Table.Cell>{t.from_time}</Table.Cell>
                              <Table.Cell>{t.description}</Table.Cell>
                              <Table.Cell
                                style={{ textAlign: 'right' }}
                                className="fixed-width"
                              >
                                {formatCurrency('£', t.amountPounds)}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </>
                  ))}
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid>
        </Container>
      </div>
    </div>
  );
};
